import Styled from "styled-components";

export interface ContentProps {
  $img: string;
}

export interface IllustrationContainerProps {
  $showBigBanner?: boolean;
}

export interface IllustrationProps {
  $showBigBanner?: boolean;
}

export const Container = Styled.div`
  padding: 2rem 0;

  ${(props) => props.theme.breakpoints.up("xlarge")} {
    padding: 16rem 0 16rem;
  }
`;

export const Content = Styled.div<ContentProps>`
  display: flex;
  position: relative;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  width: ${(props) => props.theme.width};
  max-width: calc(100% - 2.5rem);
  gap: 1.875rem;
  margin: 0 auto;

  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: calc(100% - 3rem);
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: calc(100% - 10rem);
    width: 96.75rem;
  }
`;

export const IllustrationContainer = Styled.div<IllustrationContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 20.4rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: 40rem;
  }

  ${(props) => props.theme.breakpoints.up("xlarge")} {
    display: none;
  }
`;

export const Illustration = Styled.img<IllustrationProps>`
  width: 100%;
  height: 100%;
`;

export const BigBannerContainer = Styled.div`
  display: none;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: -1;

  ${(props) => props.theme.breakpoints.up("xlarge")} {
    display: flex;
  }
`;

export const BigBannerIllustration = Styled.img`
  width: 70.25rem;
  margin: 0 auto;
`;

export const Message = Styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  
  ${(props) => props.theme.breakpoints.up("xlarge")} {
    gap: 1.875rem;
  }
`;

export const Tagline = Styled.span`
  color: #7F7F7F;
  font-size: 1rem;
  font-weight: 600;

  ${(props) => props.theme.breakpoints.up("xlarge")} {
    font-size: 1.25rem;
  }
`;

export const Pitch = Styled.div`
  max-width: 34.375rem;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.5rem;
  letter-spacing: -0.2px;
  text-align: center;

  ${(props) => props.theme.breakpoints.up("xlarge")} {
    font-size: 1.624rem;
    line-height: 2rem;
    max-width: 51.75rem;
  }

  & > p {
    margin: 1rem 0;
  }

  & > p:first-child {
    margin-top: 0;
  }

  & > p:last-child {
    margin-bottom: 0;
  }
`;

export const Link = Styled.a`
  text-decoration: none;
`;

export const ButtonsContainer = Styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 1.25rem;
`;
